'use strict';

/**
 *
 * @name: nnXSeries
 *
 **/

import DirectiveTemplate from './nn-x-series.directive.html';

function NnXSeriesDirective() {

  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    controller: nnXSeriesController,
    controllerAs: 'seriesList'
  };
}

function nnXSeriesController(
  $scope,
  apiModulesService,
  transObject
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  var seriesList = this;
  seriesList.content = $scope.content();
  seriesList.data = apiModulesService.checkIfModuleHasData(seriesList.content) ? seriesList.content.series : [];

  /**
   *
   * @PUBLIC_METHODS
   *
   */

  /**
   *
   * @PRIVATE_METHODS
   *
   */

  function _translateSeries() {

    seriesList.data.forEach(function(topic) {

      transObject.translate(topic);
    });
  }

  function _getOrderArray(data) {

    return Object.keys(data)
      .map(function(key) {
        return data[key].seriesId;
      });
  }

  /**
   *
   * @INIT
   *
   */

  if (seriesList.data.length) {

    _translateSeries();

    try {
      var order = _getOrderArray(seriesList.content.jsonData.sources);
      seriesList.data = seriesList.data
        .map(function(item){
          item.order = order.indexOf(item.id);
          return item;
        })
        .sort(function(a,b){
          return a.order > b.order;
        });
    } catch(error){

    }

  } else {

    // _loadSeries();
  }
}

export default NnXSeriesDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-x-series/nn-x-series.directive.js